import List from "./list/SettlementList";

export default { List };
